<template>
    <div class="llm-width">
        <div style="text-align: right; margin-bottom: 10px">
            <a-button @click="redo"><redo-outlined/></a-button>
        </div>
        <a-table
                :columns="columns" :data-source="dataSource" :loading="loading"
                :pagination="{showTotal: total=> total + ' items'}">
            <template
                    #customFilterDropdown="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
            >
                <div style="padding: 8px">
                    <a-input
                            ref="searchInput"
                            :placeholder="`Search ${column.dataIndex}`"
                            :value="selectedKeys[0]"
                            style="width: 188px; margin-bottom: 8px; display: block"
                            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                            @pressEnter="handleSearch(selectedKeys, confirm, column.dataIndex)"
                    />
                    <a-button
                            type="primary"
                            size="small"
                            style="width: 90px; margin-right: 8px"
                            @click="handleSearch(selectedKeys, confirm, column.dataIndex)"
                    >
                        <template #icon><SearchOutlined /></template>
                        Search
                    </a-button>
                    <a-button size="small" style="width: 90px" @click="handleReset(clearFilters)">
                        Reset
                    </a-button>
                </div>
            </template>
            <template #customFilterIcon="{ filtered }">
                <search-outlined :style="{ color: filtered ? '#108ee9' : undefined }" />
            </template>
            <template #bodyCell="{ column, record, index }">
                <template v-if="column.dataIndex === 'name'">
                    <task-type-tag :task-type="record.type" :text="record.name"/>
                </template>
                <template v-else-if="column.dataIndex === 'Download'">
                    <a-button type="link" :disabled="!record.path" @click="()=>showModal(record, index)">
                        <file-markdown-two-tone/>
                    </a-button>
                </template>
                <template v-else-if="column.dataIndex === 'description'">
                    <more-o-r-less :text="record.description" :len="25" :noTip="true"/>
                </template>
                <template v-else-if="column.title === 'Input' || column.title === 'Output'">
                    <div v-for="(param, index) in record[column.dataIndex]" :key="index">
                        {{column.title}}
                        <span v-if="record[column.dataIndex].length > 1">{{index + 1}}</span>:
                        <a-tooltip :title="param.description">
                            <a>
                                {{param.name}} | {{param.type}} <file-text-outlined/>
                            </a>
                        </a-tooltip>
                    </div>
                </template>
            </template>
        </a-table>
        <a-modal v-model:open="open" @ok="handleOk"
                 :title="mdTitle"
                 width="800px" body-style="max-height:500px;overflow-y:auto">
            <div v-if="mdLoading" style="width: 100%;height: 300px; padding-top: 150px; text-align: center">
                <a-spin :spinning="mdLoading"/>
            </div>
            <simple-code v-else :data="mdContent"/>
        </a-modal>
    </div>
</template>

<script>
    // import {ref} from 'vue';
    import {get_batch_task_tools} from "../utils/biomed.api";
    import {formatTime, down_file, compare, get_file_content} from "../utils/request";
    import {RedoOutlined, SearchOutlined, FileTextOutlined,
        FileMarkdownTwoTone
        } from '@ant-design/icons-vue';
    import MoreORLess from "../components/MoreORLess";
    import SimpleCode from "../components/SimpleCode";
    import TaskTypeTag from "../biomed-components/TaskTypeTag";

    export default {
        name: "ToolList",
        components: {
            FileMarkdownTwoTone,
            // DownloadOutlined,
            SearchOutlined,
            FileTextOutlined,
            RedoOutlined, MoreORLess,
            SimpleCode,
            TaskTypeTag
        },
        data(){
            // const searchInput = ref();
            return {
                dataSource: [],
                loading: true,
                open: false,
                mdTitle: '',
                mdContent: '',
                mdLoading: true,
                searchText: '',
                searchedColumn: 0,
                columns: [
                    {
                        title: 'Tool name',
                        dataIndex: 'name',
                        key: 'name',
                        width: 300,
                        sorter: {
                            compare: compare('name'),
                        },
                        customFilterDropdown: true,
                        onFilter: (value, record) =>
                            record.name.toString().toLowerCase().includes(value.toLowerCase()),
                    },
                    {
                        title: 'Description',
                        dataIndex: 'description',
                        sorter: {
                            compare: compare('description'),
                        },
                        width: '820px'
                    },
                    {
                        title: 'Document',
                        dataIndex: 'Download',
                        align: 'center'
                    },
                ]
            }
        },
        created(){
            this.getItems();
        },
        methods: {
            formatTime,
            down_file,
            handleSearch (selectedKeys, confirm, dataIndex) {
                confirm();
                this.searchText = selectedKeys[0];
                this.searchedColumn = dataIndex;
            },
            handleReset(clearFilters) {
                clearFilters({ confirm: true });
                this.searchText = '';
            },
            getItems(){
                let obj = this;
                obj.loading = true;
                get_batch_task_tools( data =>{
                    console.log('get_batch_task_tools', data);
                    if(Array.isArray(data)){
                        data = data.map((item, index)=>{
                            return {
                                ...item,
                                key: index
                            }
                        })
                    }
                    obj.loading = false;
                    obj.dataSource = data || [];
                })
            },
            redo(){
                this.getItems();
            },
            showModal(record, index){
                this.open = true;
                this.mdLoading = true;
                let {path: file_path, md, name} = record;
                this.mdTitle = name;
                console.log(record);
                if(!md) get_file_content({file_path}, res=>{
                    let {data, message} = res;
                    this.mdLoading = false;
                    this.mdContent = data || message;
                    this.dataSource[index].md = data;
                });
                else {
                    this.mdLoading = false;
                    this.mdContent = md;
                }
            }
        }
    }
</script>

<style scoped>

</style>